import React from 'react';
import {useSelector} from 'react-redux';
import OrderItemListMenu from '../../commons/orderItmesListMenu';
import DisplayLogs from '../../commons/displayLogs';
import {getUnscannedItemsTitle} from '../scanpack/scanBarcodeFunctions';
import ScannedItemsList from './ScannedItemsList';
import UnScannedItemsList from './UnScannedItemsList';
import upArrow from '../../../assets/up_arrow.png';
import downArrow from '../../../assets/down_arrow.png';
import useMobileTabState from './hooks/useMobileTabState';
import MobileMultiBoxBar from './MobileMultiBoxBar';

const MobileItemTabs = ({showSuggestedItem, toggleSuggestedItem}) => {
  const currentOrder = useSelector(state => state.scanPackScanning.currentOrder);
  const localLogs = useSelector(state => state.scanPackScanning.localLogs);
  const multiBoxActive = useSelector(
    state => state.user.bothSettings?.data?.data?.general_setting?.multi_box_shipments
  );

  const {
    scannedList,
    unScannedList,
    logList,
    showScannedListTab,
    showUnScannedListTab,
    showLogListTab,
  } = useMobileTabState();

  const unScannedItems = currentOrder?.unscanned_items || [];
  const scannedItems = currentOrder?.scanned_items || [];
  const unScannedCount = unScannedItems.length;
  const scannedCount = scannedItems.length;

  return (
    <>
      <OrderItemListMenu
        showScannedList={showScannedListTab}
        showUnScannedList={showUnScannedListTab}
        showLogList={showLogListTab}
        unScannedCount={unScannedCount}
        scannedCount={scannedCount}
        scannedList={scannedList}
        unScannedList={unScannedList}
        logList={logList}
        navButtonLeft={toggleSuggestedItem}
        icon={showSuggestedItem ? upArrow : downArrow}
        unScannedLabel={getUnscannedItemsTitle(unScannedItems)}
      />
      <MobileMultiBoxBar
        scannedList={scannedList}
        unScannedList={unScannedList}
        showUnScannedListTab={showUnScannedListTab}
      />
      {scannedList && <UnScannedItemsList />}
      {unScannedList && <ScannedItemsList />}
      {logList && localLogs?.length > 0 && (
        <DisplayLogs logs={localLogs} sliceNum={14} checkMultiBoxActive={multiBoxActive} />
      )}
    </>
  );
};

export default MobileItemTabs;
